const raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame
const cancelRaf = window.cancelAnimationFrame || window.mozCancelAnimationFrame

class Sticky {
  constructor (el) {
    this.$el = el
    this.update()
    this.raf = raf(this.animate)
  }

  update () {
    this.bodyHeight = document.body.offsetHeight
    this.top = this.bodyHeight - this.$el.offsetHeight - 40
  }

  animate = () => {
    const scrollY = window.pageYOffset
    if (scrollY > this.top) {
      this.$el.style.position = `fixed`
      this.$el.style.top = `40px`
    } else {
      this.$el.style.position = `inherit`
      this.$el.style.top = `0`
    }
    this.raf = raf(this.animate)
  }

  die () {
    cancelRaf(this.raf)
  }
}

export { Sticky as default }



// WEBPACK FOOTER //
// ./src/services/sticky.js